import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import FormBuilderContainer from "@jumbo/Dashboards/FormBuilder";
import { useRouteMatch } from "react-router";
import FormRequests from "services/FormBuilder";
import { setSingleForm } from "redux/actions/FormBuilder";
import { Box, Typography } from "@material-ui/core";
import Reassessment from '@jumbo/Dashboards/FormBuilder/Reassessment';
import FormPreviewButton from "@jumbo/Dashboards/FormBuilder/FormPreviewButton";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.formBuilder"} />, isActive: true },
];

const FormBuilder = () => {
  const { params } = useRouteMatch();
  const dispatch = useDispatch();
  const { form } = useSelector(({ formBuilder }) => formBuilder);

  useEffect(() => {
    if (params?.id) {
      dispatch(FormRequests.getFormById(params.id));
    } else {
      dispatch(setSingleForm(null));
    }
  }, [params, dispatch]);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.formBuilder" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <Typography>{form?.title}</Typography>
            <Box display="flex" flexWrap="wrap" alignItems="center" style={{ gap: 8 }}>
              {params?.id && <FormPreviewButton formId={params.id} variant="outlined" />}
              {form?._id === params?.id && form?.type === 'Exam' && <Reassessment key={form._id} form={form} />}
            </Box>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <FormBuilderContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default FormBuilder;
